<template>
  <v-container fluid class="pa-2">

    <!-- Radnje stoje u traci uz naziv dokumenta, a ne kao red gumba iznad
         kartice - isto kao na ostalim ekranima. Kanta je odmaknuta desno i
         samo ikona, da se ne klikne u prolazu. -->
    <div class="traka">
      <h2 class="naslov">{{ documentNameLoc || 'Račun' }}</h2>
      <div class="podatak">
        <span v-if="brojKnjizenja">knjiženje {{ brojKnjizenja }}</span>
        <span v-if="poslovnaGodina"> &middot; {{ poslovnaGodina }}</span>
      </div>
      <div class="radnje">
        <v-btn
          v-if="$store.state.user.AccessLevel <= 3 && allowFin"
          small color="white" class="plavi-tekst" @click="mainledgerDetails"
        >{{ $store.state.language === 'EN' ? 'Details' : 'Detalji' }}</v-btn>

        <v-btn
          v-if="$store.state.user.AccessLevel <= 3"
          small color="white" class="plavi-tekst" @click="mainledgerEdit"
        >{{ $store.state.language === 'EN' ? 'Edit' : 'Uredi' }}</v-btn>

        <v-btn small text dark @click="mainledgerlist"
        >{{ $store.state.language === 'EN' ? 'Back' : 'Natrag' }}</v-btn>

      </div>
    </div>

    <v-card tile>
      <v-card-text class="pt-3">
        <app-main-ledger-view2 v-if="show === 1 || show === 2"></app-main-ledger-view2>
        <app-main-ledger-view3 v-if="show === 3"></app-main-ledger-view3>
        <app-main-ledger-view4 v-if="show === 4"></app-main-ledger-view4>
      </v-card-text>

      <!-- Kanta stoji na dnu, odmaknuta od radnji koje se koriste svaki dan -
           u traci je bila nadohvat ruke, a brise cijeli racun. -->
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn
          v-if="$store.state.user.AccessLevel <= 2"
          text small color="red darken-2"
          :title="$store.state.language === 'EN' ? 'Delete invoice' : 'Obriši račun'"
          @click="mainledgerDelete"
        ><v-icon small>mdi-trash-can</v-icon></v-btn>
        <v-spacer></v-spacer>
        <v-btn small text @click="mainledgerlist"
        >{{ $store.state.language === 'EN' ? 'Back' : 'Natrag' }}</v-btn>
      </v-card-actions>
    </v-card>

    <div class="pink darken-2" v-html="error" />
  </v-container>
</template>

<script>
import MainLedgerView2 from './MainLedgerView2'
import MainLedgerView3 from './MainLedgerView3'
import MainLedgerView4 from './MainLedgerView4'
import ledgerEN from './MainLedgerDescEN'
import ledgerHR from './MainLedgerDescHR'
import commEn from "@/language/commonEN"
import commHr from "@/language/commonHR"

export default {
  name: 'mainledgerview',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      mainledger: {},
      documentName: '',
      documentNameLoc: '',
      error: null,
      localError: false,
      mainledgerActiv: {},
      havePath: null,
      show: 1,
      retPath: 'mainledger',
      lang: null,
      langC: null,
      privateP: false,
      finance3: false,
      allowFin: false
    }
  },
  components: {
    appMainLedgerView2: MainLedgerView2,
    appMainLedgerView3: MainLedgerView3,
    appMainLedgerView4: MainLedgerView4,
  },
  mounted () {
    if (this.$store.state.language === "EN") {
      this.lang = ledgerEN
      this.langC = commEn;
    }
    if (this.$store.state.language === "HR") {
      this.lang = ledgerHR
      this.langC = commHr;
    }
    this.privateP = "privatePartner" in this.$store.state.user ? this.$store.state.user.privatePartner : true
    this.finance3 = "finance3" in this.$store.state.user ? this.$store.state.user.finance3 : true
    if (!this.privateP) {
      this.allowFin = true
    }
    if (this.finance3) {
      this.allowFin = true
    }

    this.documentName = this.$store.state.documentActiv
    this.documentNameLoc = this.$store.state.documentActivLoc
    if (this.$store.state.documentSide === 1 || this.$store.state.documentSide === 2) {
      this.show = 1
      this.retPath = 'mainledger'
    }
    if (this.$store.state.documentSide === 3) {
      this.show = 3
      this.retPath = 'mainledger3'
    }
    if (this.$store.state.documentSide === 4) {
      this.show = 4
      this.retPath = 'mainledger4'
    }
    this.havePath = this.retPath ? this.retPath : ''
  },
  computed: {
    brojKnjizenja () {
      const m = this.$store.state.mainledgerActiv
      return m && m.BookID ? parseInt(m.BookID, 10) : null
    },
    poslovnaGodina () {
      return this.$store.state.businessYear ? parseInt(this.$store.state.businessYear, 10) : null
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}.${month}.${year}`
    },
    parseDate (date) {
      if (!date) {
        return null
      }
      const [day, month, year] = date.split('.')
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },
    close () {
      this.show = false
    },
    async mainledgerlist () {
      try {
        this.havePath = this.retPath ? this.retPath : ''
        this.$store.dispatch('setretPath', '')
        if (this.havePath !== 'mainledger' && this.havePath.length > 0) {
          await this.$router.push({
            name: this.havePath
          })
        } else {
          await this.$router.push({
            name: 'mainledger'
          })
        }
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async mainledgerDelete () {
      try {
        await this.$router.push({
          name: 'mainledgerdelete'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async mainledgerEdit () {
      try {
        this.$store.dispatch('seteditItem', 1)
        if(this.havePath) {
          if (this.havePath !== 'mainledger' && this.havePath.length > 0) {
            await this.$router.push({
              name: 'mainledgercreate3'
            })
          } else {
            await this.$router.push({
              name: 'mainledgercreate'
            })
          }
        } else {
          await this.$router.push({
              name: 'mainledgercreate'
          })
        }
        
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async mainledgerDetails () {
      try {
        this.$store.dispatch('setMainLedgerTotals', 1)
        await this.$router.push({
          name: 'mainledgerdetail'
        })
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    },
    async mainledgeragain () {
      try {
        this.$forceUpdate()
      } catch (err) {
        // eslint-disable-next-line
        console.log(err)
      }
    }
  },
  watch: {
  }
}
</script>

<style scoped>
.traka {
  background: #0d47a1;
  color: #fff;
  padding: 8px 14px;
  display: flex;
  align-items: center;
  gap: 14px;
  flex-wrap: wrap;
  border-radius: 4px 4px 0 0;
}
.naslov { font-size: 18px; font-weight: 500; margin: 0; }
.podatak { font-size: 13px; opacity: .9; }
.radnje { margin-left: auto; display: flex; gap: 8px; align-items: center; flex-wrap: wrap; }
.plavi-tekst { color: #0d47a1 !important; }

@media (max-width: 600px) {
  .radnje { width: 100%; margin-left: 0; }
}
</style>

